import React, { useEffect, useRef, useState } from "react";
import {
  AttachmentSection,
  Button,
  DocumentsList,
  FormFieldSet,
  Modal,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
  useFormHandler,
} from "../../../../components/index";
import { v4 as uuidv4 } from "uuid";
import { documentTypeOptions } from "../../../../assets/data/projectData";
import { EmploymentType } from "../../../../assets/data/enumData";
import { useDispatch, useSelector } from "react-redux";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../redux/slices/universal/documentsSlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import {
  getClientOneStart,
  updateClientStart,
} from "../../../../redux/slices/client/clientSlice";
import useDropdownData from "../../../../hooks/useDropdownData";
import { useNavigate } from "react-router-dom";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  clearDocuments,
  getAllDocumentsStart,
} from "../../../../redux/slices/document/documentSlice";
import { formatWords2 } from "../../../../utils/stringUtils";

const Documents = ({ setActiveTab, isEditable, editClient = "", clientId }) => {
  const [dropdownSource, setDropdownSource] = useState("placements");
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const [docs, setDocs] = useState([]);
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;

  const clientProfileUiid = useSelector(
    (state) => state.client.clientProfileUiid
  );
  const clientDetails = useSelector(
    (state) => state.client.currentClient.clientDetails
  );
  const documents = useSelector((state) => state.documents.documents) || [];
  const navigate = useNavigate();
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    if (clientProfileUiid) {
      dispatch(
        getClientOneStart({
          clientUiid: clientProfileUiid,
          retrieve: `documents`,
          ref: "DocPlacement",
        })
      );
      const filter = {
        "parent.client": { type: "NONE", value: clientProfileUiid },
        // docType: {
        //   type: "EXCLUDE",
        //   value: [
        //     "Passport",
        //     "I94",
        //     "Everify",
        //     "certified LCA",
        //     "online Paper",
        //     "Visa",
        //   ],
        // },
      };
      dispatch(
        getAllDocumentsStart({
          filter,
        })
      );
    }
    return () => {
      dispatch(clearDocuments());
    };
  }, [clientId]);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        documentType: "",
        selectPlacement: [],
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            documentStatus: "",
            expiryDate: "",
            chooseFiles: [],
          },
        ],
      },
      {
        documentType: { type: "select" },
        selectPlacement: { type: "select" },
        attachments: [
          {
            attachmentName: {
              type: "text",
              // required: true,
              minLength: 2,
            },
            chooseFiles: {
              type: "file",
              // required: true,
            },
          },
        ],
      }
    );

  //working one
  // useEffect(() => {
  //   if (clientProfileUiid) {
  //     const input = clientDetails?.documents || [];

  //     const result = [];
  //     const seen = new Set();

  //     input.forEach((group) => {
  //       const placements = group.placement || [];

  //       group.list.forEach((item) => {
  //         const docType = item.docType;

  //         item.file.forEach((f) => {
  //           f.keys.forEach((k) => {
  //             placements.forEach((p) => {
  //               const uniqueId = `${p}-${docType}-${f.name}-${k}`;
  //               if (!seen.has(uniqueId)) {
  //                 result.push({
  //                   placement: p,
  //                   docType,
  //                   name: docType + "-" + f.name + "-" + p,
  //                   filePath: k,
  //                 });
  //                 seen.add(uniqueId);
  //               }
  //             });
  //           });
  //         });
  //       });
  //     });

  //     setDocs(result);
  //     console.log(result);
  //   }
  // }, [clientDetails]);

  // useEffect(() => {
  //   if (clientProfileUiid) {
  //     let result = [];

  //     clientDetails?.documents?.forEach((doc) => {
  //       doc.placement?.forEach((placement) => {
  //         doc.list?.forEach((item) => {
  //           if (item.file?.length) {
  //             item.file.forEach((f) => {
  //               f.keys?.forEach((path) => {
  //                 if (path) {
  //                   result.push({
  //                     name: f.name || item.name || 'Untitled',
  //                     placement,
  //                     filePath: path
  //                   });
  //                 }
  //               });
  //             });
  //           } else if (item.filePath?.length) {
  //             item.filePath.forEach((path) => {
  //               if (path) {
  //                 result.push({
  //                   name: item.name || 'Untitled',
  //                   placement,
  //                   filePath: path
  //                 });
  //               }
  //             });
  //           }
  //         });
  //       });
  //     });

  //     const unique = Array.from(
  //       new Map(result.map(obj => [`${obj.placement}-${obj.filePath}`, obj])).values()
  //     );

  //     setDocs(unique);
  //   }
  // }, [clientDetails]);

  //testing
  useEffect(() => {
    if (clientProfileUiid && documents) {
      const input = clientDetails?.documents || [];

      const result = [];
      const seen = new Set();

      input.forEach((group) => {
        const placements = group.placement || [];
        const documentIds = group.list || [];

        // For each placement, combine with each document
        placements.forEach((placement) => {
          documentIds.forEach((docId) => {
            // Find the matching document from the documents array
            const documentData = documents.find((doc) => doc.uiid === docId);

            if (documentData) {
              // Process each file in the document
              documentData.file.forEach((file) => {
                // Create unique ID based on placement, document, and file
                const uniqueId = `${placement.uiid}-${docId}-${file.name}`;

                if (!seen.has(uniqueId)) {
                  result.push({
                    // Employee details from placement
                    employeeName:
                      [
                        placement.employeeId?.firstName,
                        placement.employeeId?.lastName,
                      ]
                        .filter(Boolean)
                        .join(" ") || null, // This field doesn't exist in the data structure
                    employeeUiid: placement.employeeId?.uiid || " - ",
                    employeeType: placement.employeeId?.employementType || "-",
                    employeeId: placement.employeeId?.uiid || "-",

                    // Job details from placement
                    jobTitle: placement.jobInfo?.jobTitle,
                    jobCode: placement.jobInfo?.jobCode,
                    startDate: placement.jobInfo?.startDate,

                    // Document details from documents array
                    type: formatWords2(documentData.docType),
                    title: file.name,
                    expiryDate: file.expiry,
                    status: file.status,
                    keys: file.keys, // This will be an array of file paths
                  });
                  seen.add(uniqueId);
                }
              });
            }
          });
        });
      });

      setDocs(result);
    }
  }, [clientDetails, documents]); // Added documents to dependency array
  const {
    data: allSelectPlacementListOptions,
    searchValue: allSelectPlacementSearch,
    handleSearch: handleSelectPlacementSearch,
    resetSearch: resetAllSelectPlacementSearch,
    handleScroll: handleAllSelectPlacementScroll,
  } = useDropdownData(
    // "placements",
    "clientPlacements",
    10,
    {},
    {
      //for tetsing show all employee
      //if wnat for spcific cliuents paceement open this comment👇
      entityId: clientProfileUiid,
      //to test only employees
      // entityId: 1,
      entityType: "Client",
    }
  );

  // const {
  //   data: allSelectEmployeeListOptions,
  //   searchValue: allSelectEmployeeSearch,
  //   handleSearch: handleSelectEmployeeSearch,
  //   resetSearch: resetAllSelectEmployeeSearch,
  //   handleScroll: handleAllSelectEmployeeScroll,
  // } = useDropdownData("employees", 10, {}, {});

  useEffect(() => {
    if (allSelectPlacementListOptions?.length > 0) {
      setDropdownSource("placements");
    } else {
      setDropdownSource("employees");
    }
  }, [allSelectPlacementListOptions]);
  const dropdownOptions =
    dropdownSource === "placements"
      ? {
          options: allSelectPlacementListOptions,
          search: allSelectPlacementSearch,
          onSearch: handleSelectPlacementSearch,
          onReset: resetAllSelectPlacementSearch,
          onScroll: handleAllSelectPlacementScroll,
        }
      : {
          // options: allSelectEmployeeListOptions,
          // search: allSelectEmployeeSearch,
          // onSearch: handleSelectEmployeeSearch,
          // onReset: resetAllSelectEmployeeSearch,
          // onScroll: handleAllSelectEmployeeScroll,
        };

  const handleFileChange = (id, selectedFiles) => {
    const fileArray = Array.from(selectedFiles);
    setFormData((prevData) => ({
      ...prevData,
      documents: prevData.documents.map((doc) =>
        doc.id === id ? { ...doc, files: fileArray } : doc
      ),
    }));
  };

  const addDocumentAfter = (index) => {
    const newDocument = {
      id: uuidv4(),
      attachmentName: "",
      attachmentComments: "",
      documentStatus: "",
      expiryDate: "",
      chooseFiles: [],
    };

    setFormData((prevData) => {
      const updatedDocs = [...prevData.attachments];
      updatedDocs.splice(index + 1, 0, newDocument);
      return { ...prevData, attachments: updatedDocs };
    });
  };

  const removeDocument = (id) => {
    setFormData((prevData) => ({
      ...prevData,
      documents: prevData.attachments.filter((doc) => doc.id !== id),
    }));
  };

  const handleDocumentChange = (id, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      documents: prevData.attachments.map((doc) =>
        doc.id === id ? { ...doc, [field]: value } : doc
      ),
    }));
  };

  const handleSave = () => {
    const hasFiles = formData.attachments.some(
      (att) => att.chooseFiles && att.chooseFiles.length > 0
    );
    if (!hasFiles) {
      navigate("/client");
      return;
    }
    const isValid = validateAllFields();
    if (isValid) {
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          att.documentStatus.trim() !== "" ||
          att.expiryDate.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0)
      );
      dispatch(
        updateClientStart({
          uiid: clientProfileUiid,
          coll: "Client",
          tPath: "documents",
          payload: [
            {
              type: "PUSH",
              value: {
                documents: {
                  // list: formData.documentType?.value || undefined,
                  placement:
                    // formData.selectPlacement?.value?.split(":")[0] || undefined,
                    formData.selectPlacement?.map((item) =>
                      Number(item?.split(":")[0])
                    ) || undefined,
                },
              },
            },
          ],
          onSuccess: async (updateRes) => {
            if (cleanAttachments.length > 0) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: clientProfileUiid,
                  entity: "clients",
                  category: "documents",
                  coll: "Client",
                  doc: formData.attachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    })
                  ),
                  onSuccess: async (fileData) => {
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Client",
                        refId: clientProfileUiid,
                        refField: `documents.$[elem].list`,
                        refPatchId: updateRes.targetPatchId,
                        isRefFieldArray: true,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              addedBy: loginUserUiid,
                              parent: {
                                client: clientProfileUiid,
                                placement: formData.selectPlacement?.map(
                                  (item) => Number(item?.split(":")[0])
                                ),
                              },
                              // docType: formData.documentType,
                              docType: formData.documentType.value,
                              ref: {
                                id: clientProfileUiid,
                                entity: "Client",
                                path: `documents.${updateRes.targetPatchId}.list`,
                              },
                              file: formData.attachments.map((obj) => ({
                                // id: obj.id,
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                status: obj.documentStatus,
                                expiry: obj.expiryDate,
                                // addedBy: loginUserUiid,
                                keys: fileData.map(
                                  (file) =>
                                    file.fileRefId === obj.id && file.key
                                ),
                              })),
                            },
                          ],
                        },
                        onSuccess: (docRes) => {
                          dispatch(
                            getClientOneStart({
                              clientUiid: clientProfileUiid,
                              retrieve: `documents`,
                              ref: "DocPlacement",
                            })
                          );
                          // mainBackTab()
                          navigate("/client");
                        },
                      })
                    );
                  },
                })
              );
            }
          },
        })
      );
    } else {
      console.log("Please fix the errors before submitting.");
      showToast("Please fill all the required fields before saving", "error");
    }
  };

  const handleBack = () => {
    setTimeout(() => {
      setActiveTab((prev) => prev - 1);
    }, 500);
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////
  const columns = [
    {
      key: "employeeName",
      label: "Consultant Name",
    },

    {
      key: "employeeId",
      label: "Consultant Code",
    },
    {
      key: "jobTitle",
      label: "Placement",
    },
    {
      key: "jobCode",
      label: "Job Code",
    },
    {
      key: "type",
      label: "Document Type",
    },
    {
      key: "title",
      label: "Title",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags tag={row.status == 1 ? "Active" : "Inactive"} />
      ),
    },
    {
      key: "keys",
      label: "Document",
      render: (row) => {
        const updateFiles = (row?.keys || []).map((key) => ({
          filePath: key,
          name: row?.type || "client documents",
        }));
        return (
          <div className="flex items-center">
            <Button
              variant="text"
              icon={"download"}
              color="info"
              size="sm"
              title={row.document}
              iconPosition="after"
              onClick={() => setSelectedDocuments(updateFiles)}
              disabled={updateFiles.length === 0}
            />
          </div>
        );
      },
    },
  ];

  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(docs, columns);
  return (
    <div className="flex flex-col w-full h-screen px-8 py-3 overflow-auto rounded">
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Documents"} icon={"badge"} tag="h5" />
            </div>
          }
          RightSection={
            <>
              {isEditable && editClient && (
                <>
                  {editClient !== "/client/client-details" && (
                    <Button
                      title="Back"
                      size="sm"
                      icon={"arrow_left_alt"}
                      onClick={handleBack}
                    />
                  )}

                  <Button title="Save" size="sm" onClick={handleSave} />
                </>
              )}
            </>

            // <>
            //   <Button
            //     title="Back"
            //     size="sm"
            //     icon={"arrow_left_alt"}
            //     onClick={handleBack}
            //   />
            //   <Button title="Save" size="sm" onClick={handleSave} />
            // </>
          }
        />
      </div>
      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <FormFieldSet
          type="documentTypes"
          title={"Document Type"}
          placeholder="Select"
          value={formData.documentType}
          onChange={(value) => handleChange("documentType", value)}
          error={errors.documentType}
          options={documentTypeOptions}
          showButton
          showSearch
          required
          disabled={!isEditable}
        />

        <FormFieldSet
          type="select"
          multiple
          title={"Select Placement"}
          placeholder="Select"
          // options={EmploymentType}
          options={
            dropdownOptions.options?.filter((placement) => {
              const endDate = new Date(placement?.jobInfo?.endDate);
              const today = new Date();
              return !placement?.jobInfo?.endDate || endDate >= today;
            }) || []
          }
          keyname="employees"
          value={formData.selectPlacement}
          // onChange={(value) => handleChange("selectPlacement", value)}
          onChange={(value) => {
            return handleChange("selectPlacement", value);
          }}
          error={errors.selectPlacement}
          // showButton
          showSearch
          searchValue={dropdownOptions.search}
          onClose={dropdownOptions.onReset}
          refData={containerRef}
          onSearch={dropdownOptions.onSearch}
          handleScroll={() => dropdownOptions.onScroll(containerRef)}
          disabled={!isEditable}
        />
      </div>
      <div className="mt-6 ">
        <PageHeader
          Section={
            <div className="flex">
              {" "}
              <PageTitle title={"Documents List"} tag="h6" />
            </div>
          }
        />
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(value) => handleChange("attachments", value)}
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
          showDocumentStatusField={true}
          showExpiryDateField={true}
          maxAttachments={100}
        />
        {/* {console.log("docs in client", docs)} */}
        {/* <DocumentsList data={docs} type="modal" /> */}
      </div>
      <div className="mt-4">
        <NewTable columns={columns} rows={mappedRows} hideToolBar />
      </div>
      <Modal
        isOpen={selectedDocuments.length > 0}
        onClose={() => setSelectedDocuments([])}
        width="max-w-2xl"
        title={"Document Details"}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default Documents;
